import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Button from '../../../shared/components/Button';

const RegistrationFormFooter = ({
  formik,
  loading,
  showPreRegisteredFields
}) => {
  const { t } = useTranslation();

  return (
    <div className='flex flex-column align-items-end'>
      <div className="mb-4">
        <Button
          variant="primary"
          data-cy="sign_up_button"
          type="submit"
          disabled={!formik.dirty || loading || !formik.isValid}>
          {
            loading
              ? <Spinner animation="border" size="sm" />
              : showPreRegisteredFields
                ? t('influencers.common.save')
                : t('influencers.pages.sign_up.sign_up')
          }
        </Button>
      </div>
      {
        !showPreRegisteredFields &&
        <Fragment>
          <div className="text-1">
            {t('influencers.pages.sign_up.already_have_account')}{' '}
            <Link to="/signin">
              {t('influencers.pages.sign_up.sign_in')}
            </Link>
          </div>
          <div className="text-1">
            {t('influencers.common.email')}{' '}
            <a href='mailto:questions@obvious.ly'>questions@obvious.ly</a>
          </div>
        </Fragment>
      }
    </div>
  );
};

RegistrationFormFooter.propTypes = {
  formik: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  showPreRegisteredFields: PropTypes.bool
};

export default RegistrationFormFooter;
